

import PageTitle from "../components/common/pageTitle";
import React, { useState, useEffect, useCallback } from "react";
import 'date-fns';
import { useHistory } from "react-router-dom";
import { makeStyles, Typography } from "@material-ui/core"
import HomeStyles from '../styles/Home.module.css'
import Polycy from '../components/common/policy-register'
import Breadcrumbs from "../components/common/Breadcrumbs";
import Banner from "../components/common/banner";
import CssTextField from '../libs/config/inputConfig';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import axios from 'axios';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withSnackbar } from "../libs/config/snackbar.config";
import FormGroup from '@material-ui/core/FormGroup';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import moment from "moment";
import CheckIcon from '@material-ui/icons/Check';
import api from '../libs/utils/axiosApiInstance'


import {
    MuiPickersUtilsProvider,
    DatePicker,
    KeyboardDatePicker
} from '@material-ui/pickers';
import OverwriteMomentBE from "../libs/config/OverwriteMomemtBE";
import DialogRegister from "../components/common/dialogRegister";


function sleep(delay = 0) {
    return new Promise((resolve) => {
        setTimeout(resolve, delay);
    });
}





const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'column'
    },
    margin: {
        marginBottom: theme.spacing(3),
    },
    title: {
        fontWeight: 'bold',
        marginBottom: '2rem',
    },
    buttonConfirm: {
        background: '#3364AF',
        fontSize: '1.0rem',
        width: '100%',
        height: '45px',
    },
    buttonUpload: {
        background: '#FBBE66',
        color: '#FFFFFF',
        fontSize: '.8rem',
        width: '100%',
        height: '54px',
    },

}));

const TypesFile = [
    {
        name: 'สำเนาบัตรประจำตัวประชาชน',
        value: 'IdCardFiles',
    },
    {
        name: 'สำเนาหนังสือจดทะเบียนนิติบุคคล',
        value: 'JuristicPersonFiles',
    },
    {
        name: 'ใบอนุญาตขายเมล็ดพันธุ์ควบคุม (พ.พ.4)',
        value: 'LicenseFiles',
    },
    {
        name: 'แผนผังแสดงที่อยู่สถานที่ตั้งของสถานที่จำหน่ายเมล็ด',
        value: 'StoreMapFiles',
    },
    {
        name: 'หนังสือมอบอำนาจ',
        value: 'ProxyFiles',
    },
    {
        name: 'เอกสารอื่นๆ',
        value: 'OtherFiles',
    },
]

const titles = [
    'นาย',
    'นาง',
    'นางสาว',
    'อื่นๆ'
]

const PersonTypes = [
    'บุคคลธรรมดา',
    'นิติบุคคล',
]


function Register(props) {

    const history = useHistory();
    const handleOnLink = useCallback(() => history.push('/confirm-email'), [history]);
    const classes = useStyles();
    const date = new Date();
    const BirthDate = date.toLocaleDateString();

    const [openIssuerProvince, setOpenIssuerProvince] = React.useState(false);
    const [openIssuerDistrict, setOpenIssuerDistrict] = React.useState(false);


    const [openProvince, setOpenProvince] = React.useState(false);
    const [openDistrict, setOpenDistrict] = React.useState(false);
    const [openSubDistrict, setOpenSubDistrict] = React.useState(false);
    const [openZipcode, setOpenZipcode] = React.useState(false);

    const [openShopProvince, setOpenShopProvince] = React.useState(false);
    const [openShopDistrict, setOpenShopDistrict] = React.useState(false);
    const [openShopSubDistrict, setOpenShopSubDistrict] = React.useState(false);
    const [openShopZipcode, setOpenShopZipcode] = React.useState(false);

    const [openOfficeProvince, setOpenOfficeProvince] = React.useState(false);
    const [openOfficeDistrict, setOpenOfficeDistrict] = React.useState(false);
    const [openOfficeSubDistrict, setOpenOfficeSubDistrict] = React.useState(false);
    const [openOfficeZipcode, setOpenOfficeZipcode] = React.useState(false);


    // const [val, setVal] = useState({
    //     Province: '',
    //     District: '',
    //     SubDistrict: '',
    //     Zipcode: '',
    // })

    const [options, setOptions] = React.useState([]);

    const [typeList, setTypeList] = useState([]);
    const [catalogList, setCatalogList] = useState([]);



    const loadingProvince = openProvince && options.length === 0;
    const loadingDistrict = openDistrict && options.length === 0;
    const loadingSubDistrict = openSubDistrict && options.length === 0;
    const loadingZipcode = openZipcode && options.length === 0;

    const loadingShopProvince = openShopProvince && options.length === 0;
    const loadingShopDistrict = openShopDistrict && options.length === 0;
    const loadingShopSubDistrict = openShopSubDistrict && options.length === 0;
    const loadingShopZipcode = openShopZipcode && options.length === 0;

    const loadingOfficeProvince = openOfficeProvince && options.length === 0;
    const loadingOfficeDistrict = openOfficeDistrict && options.length === 0;
    const loadingOfficeSubDistrict = openOfficeSubDistrict && options.length === 0;
    const loadingOfficeZipcode = openOfficeZipcode && options.length === 0;

    const loadingIssuerProvince = openIssuerProvince && options.length === 0;
    const loadingIssuerDistrict = openIssuerDistrict && options.length === 0;


    const [isLoading, setLoading] = React.useState(false);
    let [openPopup, setOpenPopup] = useState(false)
    const [branchs, setBranchs] = useState([]);
    // const [files, setFiles] = useState([]);
    const IdCardFiles = React.useRef(null);
    const JuristicPersonFiles = React.useRef(null);
    const LicenseFiles = React.useRef(null);
    const StoreMapFiles = React.useRef(null);
    const ProxyFiles = React.useRef(null);
    const OtherFiles = React.useRef(null);

    let [verifyCheck, setVerifyCheck] = useState({
        IdCardFiles: false,
        JuristicPersonFiles: false,
        LicenseFiles: false,
        StoreMapFiles: false,
        ProxyFiles: false,
        OtherFiles: false,
    })

    const [files, setFiles] = useState([]);

    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        window.location.href = '/'
    };

    useEffect(() => {

        verifyCheckChange()

    }, [files])


    const verifyCheckChange = () => {
        const IdCardFiles = files.find(x => x.typeName === "IdCardFiles");

        const JuristicPersonFiles = files.find(x => x.typeName === "JuristicPersonFiles");
        const LicenseFiles = files.find(x => x.typeName === "LicenseFiles");
        const StoreMapFiles = files.find(x => x.typeName === "StoreMapFiles");
        const ProxyFiles = files.find(x => x.typeName === "ProxyFiles");
        const OtherFiles = files.find(x => x.typeName === "OtherFiles");
        setVerifyCheck({
            IdCardFiles: IdCardFiles ? true : false,
            JuristicPersonFiles: JuristicPersonFiles ? true : false,
            LicenseFiles: LicenseFiles ? true : false,
            StoreMapFiles: StoreMapFiles ? true : false,
            ProxyFiles: ProxyFiles ? true : false,
            OtherFiles: OtherFiles ? true : false,
        });


    }




    // const handleClickUpload = event => {

    //     IdCardFiles.current.click();
    // };

    let [input, setInput] = useState({
        BranchNo: '',
        Fname: '',
        Lname: '',
        Email: '',
        Tel: '',
        Fax: '',
        HouseNumber: '',
        Moo: '',
        Alley: '',
        Nationality: '',
        Address: '',
        BirthDate: null,
        IssuerDistrict: '',
        IssuerProvince: '',
        PersonType: '',
        IssuerDate: null,
        JuristicPersonType: '',
        JuristicPersonId: '',
        AuthorizedSignatory: '',
        Province: '',
        District: '',
        SubDistrict: '',
        Zipcode: '',
        ContactName: '',
        Title: '',
        Nationality: '',
        ShopHouseNumber: '',
        ShopMoo: '',
        ShopAddress: '',
        ShopProvince: '',
        ShopDistrict: '',
        ShopSubDistrict: '',
        ShopZipcode: '',
        ShopAlley: '',
        ShopTel: '',
        ShopFax: '',
        OtherTitle: '',
        OfficeAddress: '',
        OfficeAlley: '',
        OfficeDistrict: '',
        OfficeHouseNumber: '',
        OfficeMoo: '',
        OfficeProvince: '',
        OfficeSubDistrict: '',
        OfficeZipcode: '',
        OfficeTel: '',
        OfficeFax: '',


        ItemTypeName_1: '',
        ItemCatalogName_1: '',
        ItemSaleAmount_1: null,

        ItemTypeName_2: '',
        ItemCatalogName_2: '',
        ItemSaleAmount_2: null,

        ItemTypeName_3: '',
        ItemCatalogName_3: '',
        ItemSaleAmount_3: null,
        age: '',
        ItemTypeName_4: '',
        ItemCatalogName_4: '',
        ItemSaleAmount_4: null,
        coppyNationalityToOfficeAddress: false,
        coppyShopToOfficeAddress: false,
        coppyOfficeToShopAddress: false,
        term: false
    });

    const [selectedDate, setSelectedDate] = useState();

    const handleBirthdayChange = (date) => {
        if (date) {
            const birthDay = new Date(date);
            const datenow = new Date()
            const today_year = datenow.getFullYear();
            const birth_year = birthDay.getFullYear();
            const age = today_year - birth_year;
            setInput({
                ...input,
                BirthDate: new Date(date),
                age: age
            });
        }
    };

    const handleIssuerDateChange = (date) => {
        if (date) {
            setInput({
                ...input,
                IssuerDate: new Date(date)

            });
        }
    };


    const handleClickUploadIdCardFiles = event => {

        IdCardFiles.current.click();
    };

    const handleClickUploadJuristicPersonFiles = event => {

        JuristicPersonFiles.current.click();
    };

    const handleClickUploadLicenseFiles = event => {

        LicenseFiles.current.click();
    };

    const handleClickUploadStoreMapFiles = event => {

        StoreMapFiles.current.click();
    };

    const handleClickUploadProxyFiles = event => {

        ProxyFiles.current.click();
    };
    const handleClickUploadOtherFiles = event => {

        OtherFiles.current.click();
    };




    const getPathImage = (extension) => {
        if (extension === 'png') {
            return 'icons/png.svg';
        }
        else if (extension === 'jpg') {
            return 'icons/jpg.svg';
        }
        else if (extension === 'pdf') {
            return 'icons/pdf.svg';
        }
        else if (extension === 'doc') {
            return 'icons/doc.svg';
        }
        else if (extension === 'txt') {
            return 'icons/txt.svg';
        }
        else if (extension === 'zip') {
            return 'icons/zip.svg';
        }
        else if (extension === 'xls' || extension === 'xlsx') {
            return 'icons/xls.svg';
        }
        else {
            return 'icons/file.svg';
        }

    }







    useEffect(() => {

        const fetchPost = async () => {
            const response = await api.get(`/dbms/branchs`);

            const b = await response.data
            setBranchs(b.result)
        }

        const fetchType = async () => {
            const response = await api.get(`/dbms/itemtypes`);

            const b = await response.data
            setTypeList(b.result)
        }

        const fetchCatalog = async () => {
            const response = await api.get(`/dbms/itemcatalogs`);

            const b = await response.data
            setCatalogList(b.result)
        }


        fetchPost();
        fetchType();
        fetchCatalog();

    }, []);

    const handleChangeFile = (event) => {

        const { target } = event;
        const { name } = target;
        const value = target.value;
        if (event.target.files.length > 0) {
            const fileUploaded = event.target.files[0];
            const type = TypesFile.find(x => x.value === name);
            const extension = fileUploaded.name.split('.')?.pop();
            const pathImg = getPathImage(extension);
            const fixfileUploaded = {
                file: fileUploaded,
                typeName: type.value,
                typeShow: type.name,
                typeFile: extension,
                pathImg: pathImg
            }
            const updateFiles = [
                ...files,
                fixfileUploaded
            ];
            // update the state to the updatedUsers
            setFiles(updateFiles);
        }

    };

    const handleRemove = (f) => {
        const newFiles = files.filter((files) => files !== f);

        setFiles(newFiles);
    };



    const register = () => {
        // setLoading(true);
        setOpenPopup(true);
    }






    // const handleChangeFile = e => {

    //     const { target } = e;
    //     const { name } = target;
    //     const value = target.value;
    //     setFiles({
    //         ...input,
    //         [name]: value
    //     });

    // }



    const handleClickAutoComplete = (value) => {

        if (value) {
            setInput({
                ...input,
                Province: value.ProvinceName,
                SubDistrict: value.SubDistrictName,
                Zipcode: value.Zipcode,
                District: value.DistrictName,

            });
        }

    };

    const handleSetShopAddress = (value) => {

        if (value) {
            setInput({
                ...input,
                ShopProvince: value.ProvinceName,
                ShopSubDistrict: value.SubDistrictName,
                ShopZipcode: value.Zipcode,
                ShopDistrict: value.DistrictName,

            });
        }

    };

    const handleSetOfficeAddress = (value) => {

        if (value) {
            setInput({
                ...input,
                OfficeProvince: value.ProvinceName,
                OfficeSubDistrict: value.SubDistrictName,
                OfficeZipcode: value.Zipcode,
                OfficeDistrict: value.DistrictName,

            });
        }



    };

    const coppyAddress = e => {
        const { target } = e;
        const { name } = target;
        console.log(name);
        if (name === 'coppyNationalityToShopAddress') {

            if (target.checked) {
                setInput({
                    ...input,
                    ShopHouseNumber: input.HouseNumber,
                    ShopMoo: input.Moo,
                    ShopAlley: input.Alley,
                    ShopAddress: input.Address,
                    ShopProvince: input.Province,
                    ShopSubDistrict: input.SubDistrict,
                    ShopZipcode: input.Zipcode,
                    ShopDistrict: input.District,
                });
            } else {
                setInput({
                    ...input,
                    ShopHouseNumber: '',
                    ShopMoo: '',
                    ShopAlley: '',
                    ShopAddress: '',
                    ShopProvince: '',
                    ShopSubDistrict: '',
                    ShopZipcode: '',
                    ShopDistrict: '',
                });
            }
        }

        if (name === 'coppyNationalityToOfficeAddress') {
            if (target.checked) {
                setInput({
                    ...input,
                    OfficeHouseNumber: input.HouseNumber || '',
                    OfficeMoo: input.Moo || '',
                    OfficeAlley: input.Alley || '',
                    OfficeAddress: input.Address || '',
                    OfficeProvince: input.Province,
                    OfficeSubDistrict: input.SubDistrict,
                    OfficeZipcode: input.Zipcode,
                    OfficeDistrict: input.District,
                    coppyNationalityToOfficeAddress: true,
                    coppyShopToOfficeAddress: false,
                    coppyOfficeToShopAddress: false,
                });

            } else {
                setInput({
                    ...input,
                    OfficeHouseNumber: '',
                    OfficeMoo: '',
                    OfficeAlley: '',
                    OfficeAddress: '',
                    OfficeProvince: '',
                    OfficeSubDistrict: '',
                    OfficeZipcode: '',
                    OfficeDistrict: '',
                    coppyNationalityToOfficeAddress: false,
                });
            }
        }

        if (name === 'coppyShopToOfficeAddress') {
            if (target.checked) {
                setInput({
                    ...input,
                    OfficeHouseNumber: input.ShopHouseNumber || '',
                    OfficeMoo: input.ShopMoo || '',
                    OfficeAlley: input.ShopAlley || '',
                    OfficeAddress: input.ShopAddress || '',
                    OfficeProvince: input.ShopProvince || '',
                    OfficeSubDistrict: input.ShopSubDistrict || '',
                    OfficeZipcode: input.ShopZipcode || '',
                    OfficeDistrict: input.ShopDistrict || '',
                    coppyShopToOfficeAddress: true,
                    coppyNationalityToOfficeAddress: false

                });

            } else {
                setInput({
                    ...input,
                    OfficeHouseNumber: '',
                    OfficeMoo: '',
                    OfficeAlley: '',
                    OfficeAddress: '',
                    OfficeProvince: '',
                    OfficeSubDistrict: '',
                    OfficeZipcode: '',
                    OfficeDistrict: '',
                    coppyShopToOfficeAddress: false,
                });
            }
        }
        if (name === 'coppyOfficeToShopAddress') {
            if (target.checked) {
                setInput({
                    ...input,
                    ShopHouseNumber: input.OfficeHouseNumber,
                    ShopMoo: input.OfficeMoo,
                    ShopAlley: input.OfficeAlley,
                    ShopAddress: input.OfficeAddress,
                    ShopProvince: input.OfficeProvince,
                    ShopSubDistrict: input.OfficeSubDistrict,
                    ShopZipcode: input.OfficeZipcode,
                    ShopDistrict: input.OfficeDistrict,
                    coppyOfficeToShopAddress: true,
                    coppyNationalityToOfficeAddress: false
                });
            } else {
                setInput({
                    ...input,
                    ShopHouseNumber: '',
                    ShopMoo: '',
                    ShopAlley: '',
                    ShopAddress: '',
                    ShopProvince: '',
                    ShopSubDistrict: '',
                    ShopZipcode: '',
                    ShopDistrict: '',
                    coppyOfficeToShopAddress: false,
                });
            }
        }
    }

    const handleSetIssuerAddress = (value) => {

        if (value) {
            setInput({
                ...input,
                IssuerDistrict: value.DistrictName,
                IssuerProvince: value.ProvinceName,

            });
        }



    };


    const handleChange = e => {

        const { target } = e;
        const { name } = target;


        (async () => {

            let params;
            let response;
            let c = [];
            if (name === 'Province' || name === 'ShopProvince' || name === 'OfficeProvince' || name === 'IssuerProvince') {
                params = `?P=${target.value}`
            } else if (name === 'District' || name === 'ShopDistrict' || name === 'OfficeDistrict' || name === 'IssuerDistrict') {
                params = `?D=${target.value}`
            } else if (name === 'SubDistrict' || name === 'ShopSubDistrict' || name === 'OfficeSubDistrict') {
                params = `?SD=${target.value}`
            } else if (name === 'Zipcode' || name === 'ShopZipcode' || name === 'OfficeZipcode') {
                params = `?Z=${target.value}`
            }

            if (name === 'Province' || name === 'IssuerProvince' || name === 'IssuerDistrict' || name === 'District' || name === 'SubDistrict' || name === 'Zipcode' || name === 'ShopProvince' || name === 'ShopDistrict' || name === 'ShopSubDistrict' || name === 'ShopZipcode' || name === 'OfficeProvince' || name === 'OfficeDistrict' || name === 'OfficeSubDistrict' || name === 'OfficeZipcode') {
                if (target.value) {
                    response = await api.get(`/address${params}`);
                } else {
                    response = await api.get(`/address`);
                }
                await sleep(1e3); // For demo purposes.
                const res = await response.data


                c = res.result || [];
                setOptions(c);
            }




        })();



        const value = name === 'term' ? target.checked : target.value;
        setInput({
            ...input,
            [name]: value

        });
    }

    const onSubmit = async e => {
        e.preventDefault()
        const IdCardFiles = files.filter(x => x.typeName === 'IdCardFiles');
        const JuristicPersonFiles = files.filter(x => x.typeName === 'JuristicPersonFiles');
        const LicenseFiles = files.filter(x => x.typeName === 'LicenseFiles');
        const StoreMapFiles = files.filter(x => x.typeName === 'StoreMapFiles');

        if (files.length === 0 || IdCardFiles.length === 0 || JuristicPersonFiles.length === 0 || LicenseFiles.length === 0 || StoreMapFiles.length === 0) {

            return props.snackbarShowMessage(`กรุณาอัพโหลดเอกสารที่จำเป็นในการสมัครให้ครบ`, 'error');
        }
        if (!input?.term) {
            return props.snackbarShowMessage(`กรุณายอมรับเงื่อนไขข้อตกลงในการสมัครตัวแทน`, 'error');
        }


        setLoading(true);
        if (isLoading)
            return;





        const body = input;
        const formData = new FormData();


        formData.append('BranchNo', input.BranchNo);
        formData.append('Email', input.Email);
        formData.append('Fname', input.Fname);

        formData.append('BirthDate', input.BirthDate.toISOString().slice(0, 10));
        formData.append('Lname', input.Lname);
        formData.append('NationalityId', input.NationalityId);
        formData.append('Title', input.Title === 'อื่นๆ' ? input?.OtherTitle : input.Title);

        if (input.Alley) {
            formData.append('Alley', input.Alley);
        }

        if (input.Moo) {
            formData.append('Moo', input.Moo);
        }
        if (input.Address) {
            formData.append('Address', input.Address);
        }

        if (input.HouseNumber) {
            formData.append('HouseNumber', input.HouseNumber);
        }
        if (input.ContactName) {
            formData.append('ContactName', input.ContactName);
        }
        if (input.ContactName) {
            formData.append('Tel', input.Tel);
        }
        formData.append('Province', input.Province);
        formData.append('District', input.District);
        formData.append('SubDistrict', input.SubDistrict);
        formData.append('Zipcode', input.Zipcode);

        if (input.ShopAlley) {
            formData.append('ShopAlley', input.ShopAlley);
        }
        if (input.ShopMoo) {
            formData.append('ShopMoo', input.ShopMoo);
        }
        if (input.ShopAddress) {
            formData.append('ShopAddress', input.ShopAddress);
        }

        formData.append('ShopTel', input.ShopTel);
        if (input.ShopFax) {
            formData.append('ShopFax', input.ShopFax);
        }

        formData.append('IssuerDistrict', input.IssuerDistrict);
        formData.append('IssuerProvince', input.IssuerProvince);

        formData.append('ShopHouseNumber', input.ShopHouseNumber);
        formData.append('ShopProvince', input.ShopProvince);
        formData.append('ShopDistrict', input.ShopDistrict);
        formData.append('ShopSubDistrict', input.ShopSubDistrict);
        formData.append('ShopZipcode', input.ShopZipcode);
        formData.append('Nationality', input.Nationality);

        if (input.ShopAlley) {
            formData.append('OfficeAlley', input.OfficeAlley);
        }
        if (input.OfficeMoo) {
            formData.append('OfficeMoo', input.OfficeMoo);
        }
        if (input.OfficeAddress) {
            formData.append('OfficeAddress', input.OfficeAddress);
        }

        formData.append('OfficeTel', input.OfficeTel);
        if (input.OfficeFax) {
            formData.append('OfficeFax', input.OfficeFax);
        }

        formData.append('OfficeHouseNumber', input.OfficeHouseNumber);
        formData.append('OfficeProvince', input.OfficeProvince);
        formData.append('OfficeDistrict', input.OfficeDistrict);
        formData.append('OfficeSubDistrict', input.OfficeSubDistrict);
        formData.append('OfficeZipcode', input.OfficeZipcode);
        formData.append('PersonType', input.PersonType);

        if (input.ItemTypeName_1) {
            formData.append('ItemTypeName_1', input.ItemTypeName_1);
        }
        if (input.ItemCatalogName_1) {
            formData.append('ItemCatalogName_1', input.ItemCatalogName_1);
        }
        if (input.ItemSaleAmount_1) {
            formData.append('ItemSaleAmount_1', input.ItemSaleAmount_1);
        }

        if (input.ItemTypeName_2) {
            formData.append('ItemTypeName_2', input.ItemTypeName_2);
        }
        if (input.ItemCatalogName_2) {
            formData.append('ItemCatalogName_2', input.ItemCatalogName_2);
        }
        if (input.ItemSaleAmount_2) {
            formData.append('ItemSaleAmount_2', input.ItemSaleAmount_2);
        }

        if (input.ItemTypeName_1) {
            formData.append('ItemTypeName_3', input.ItemTypeName_3);
        }
        if (input.ItemCatalogName_3) {
            formData.append('ItemCatalogName_3', input.ItemCatalogName_3);
        }
        if (input.ItemSaleAmount_3) {
            formData.append('ItemSaleAmount_3', input.ItemSaleAmount_3);
        }

        if (input.ItemTypeName_4) {
            formData.append('ItemTypeName_4', input.ItemTypeName_4);
        }
        if (input.ItemCatalogName_4) {
            formData.append('ItemCatalogName_4', input.ItemCatalogName_4);
        }
        if (input.ItemSaleAmount_4) {
            formData.append('ItemSaleAmount_4', input.ItemSaleAmount_4);
        }

        if (input.IssuerDate) {
            formData.append('IssuerDate', input.IssuerDate.toISOString().slice(0, 10));
        }

        if (input.JuristicPersonType) {
            formData.append('JuristicPersonType', input.JuristicPersonType);
        }

        if (input.JuristicPersonId) {
            formData.append('JuristicPersonId', input.JuristicPersonId);
        }

        if (input.AuthorizedSignatory) {
            formData.append('AuthorizedSignatory', input.AuthorizedSignatory);
        }





        for (const c of files) {

            formData.append(c.typeName, c.file);
        }
        const res = await api.post(`/auth/register/agent`, formData);
        if (res.data.status) {
            setLoading(false);
            // handleOnLink();
            handleClickOpen()
        } else {
            if (res.data.code === 1009) {
                props.snackbarShowMessage(`การสมัครไม่สำเร็จ อีเมลนี้ได้ถูกใช้สมัครไปแล้ว`, 'error');
            }
        }

        setLoading(false);
    }


    const renderInput = (props) => (

        <CssTextField type="text"
            onClick={props.onClick}
            value={props.value}
            onChange={props.onChange}
            className={classes.margin}
            style={{
                width: '100%'
            }}
            name={props.name}
            id={props.id}
            InputProps={{ disableUnderline: true }}
            required={props.required}
            fullWidth
            error={props.error}
            label={props.label}
        />
    );


    return (
        <>




            <Banner>
                <div className="container">
                    <PageTitle title="" header="สมัครตัวแทน" />
                    <Breadcrumbs linkName="สมัครตัวแทน" />



                    <div className="row w-100">
                        <div className="col-lg-6 col-md-12" >
                            <div className={HomeStyles.card} >
                                <Typography variant="h4" className={classes.title} >
                                    ลงทะเบียนสมัครตัวแทนจำหน่าย
                                </Typography>
                                <Typography variant="h6" style={{
                                    marginBottom: '15px'
                                }}>
                                    ข้อมูลผู้สมัคร
                                </Typography>
                                <form onSubmit={onSubmit}>
                                    <div className="row">
                                        <div className="col-12">
                                            {/* <CssTextField type="text"  required error={true} onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth  label="ศูนย์ที่ต้องการสมัคร"  /> */}
                                            <CssTextField select className={classes.margin} name="BranchNo" id="BranchNo" value={input.BranchNo} required error={true} onClick={handleChange} InputProps={{ disableUnderline: true }} fullWidth label="ศูนย์ที่ต้องการสมัคร">
                                                {/* <Select      required error={true} > */}

                                                {branchs.map((option) => (
                                                    <MenuItem key={option.BranchNo} value={option.BranchNo}>
                                                        {option.BranchName}
                                                    </MenuItem>
                                                ))}

                                                {/* </Select> */}
                                            </CssTextField>



                                        </div>
                                        <div className="col-12">


                                            <CssTextField select className={classes.margin} name="PersonType" id="PersonType" value={input.PersonType} required error={true} onClick={handleChange} InputProps={{ disableUnderline: true }} fullWidth label="ประเภทบุคคล">
                                                {/* <Select      required error={true} > */}

                                                {PersonTypes.map((option) => (
                                                    <MenuItem key={option} value={option}>
                                                        {option}
                                                    </MenuItem>
                                                ))}

                                                {/* </Select> */}
                                            </CssTextField>

                                        </div>
                                        {input?.PersonType === 'นิติบุคคล' ? <>
                                            <div className="col-6">
                                                <CssTextField type="text" required={input?.PersonType === 'นิติบุคคล'} error={true} name="JuristicPersonType" id="JuristicPersonType" onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="ประเภทนิติบุคคล" />
                                            </div>

                                            <div className="col-6">
                                                <CssTextField type="text" required={input?.PersonType === 'นิติบุคคล'} error={true} name="JuristicPersonId" id="JuristicPersonId" onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="นิติบุคคลเลขที่" />
                                            </div>
                                        </> : 
                                         <div className="col-12">
                                                <CssTextField type="text" required={input?.PersonType !== 'นิติบุคคล'} error={true} name="JuristicPersonId" id="JuristicPersonId" onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="ทะเบียนพาณิชย์" />
                                            </div>}

                                        <div className="col-6">
                                            <MuiPickersUtilsProvider utils={OverwriteMomentBE} locale="th">
                                                <DatePicker

                                                    name="IssuerDate"
                                                    id="IssuerDate"
                                                    maxDate={new Date()}
                                                    required={input?.PersonType === 'นิติบุคคล'}
                                                    error={true}
                                                    format='DD/MM/YYYY'
                                                    label="วันที่จดทะเบียน"
                                                    onChange={handleIssuerDateChange}
                                                    value={input.IssuerDate}
                                                    TextFieldComponent={renderInput}



                                                />
                                            </MuiPickersUtilsProvider>
                                        </div>
                                        <div className="col-6">
                                            <CssTextField type="text" required={input?.PersonType === 'นิติบุคคล'} error={true} name="AuthorizedSignatory" id="AuthorizedSignatory" onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="ผู้มีอำนาจลงนามแทน" />
                                        </div>

                                        <div className="col-6">


                                            <CssTextField select className={classes.margin} name="Title" id="Title" value={input.Title} required error={true} onClick={handleChange} InputProps={{ disableUnderline: true }} fullWidth label="คำนำหน้า">
                                                {/* <Select      required error={true} > */}

                                                {titles.map((option) => (
                                                    <MenuItem key={option} value={option}>
                                                        {option}
                                                    </MenuItem>
                                                ))}

                                                {/* </Select> */}
                                            </CssTextField>

                                        </div>
                                        <div className="col-6">
                                            <CssTextField type="text" required error={true} name="OtherTitle" id="Title" onChange={handleChange} required={input.Title === 'อื่นๆ'} disabled={!input.Title || input.Title !== 'อื่นๆ'} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="คำนำหน้าอื่นๆ (โปรดระบุ)" />
                                        </div>

                                        <div className="col-6">
                                            <CssTextField type="text" required error={true} name="Fname" id="Fname" onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="ชื่อ" />
                                        </div>
                                        <div className="col-6">
                                            <CssTextField type="text" required error={true} name="Lname" id="Lname" onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="นามสกุล" />
                                        </div>

                                        <div className="col-6">
                                            {/* <CssTextField className={classes.margin}  required error={true} name="BirthDate" id="BirthDate" onChange={handleChange} InputProps={{ disableUnderline: true }} inputProps={{ max: new Date().toISOString().slice(0, 10) }} InputLabelProps={{
                                                shrink: true,
                                            }} fullWidth label="วันเกิด" /> */}
                                            <MuiPickersUtilsProvider utils={OverwriteMomentBE} locale="th">
                                                <DatePicker

                                                    name="BirthDate"
                                                    id="BirthDate"
                                                    maxDate={new Date()}
                                                    format='DD/MM/YYYY'
                                                    label="วันเกิด"
                                                    required={true}
                                                    error={true}
                                                    onChange={handleBirthdayChange}
                                                    value={input.BirthDate}
                                                    TextFieldComponent={renderInput}



                                                />
                                            </MuiPickersUtilsProvider>
                                        </div>
                                        {/* <DatePicker onChange={onChange} value={new Date(2536, 7, 1)} locale="th-TH"  /> */}



                                        <div className="col-3">
                                            <CssTextField className={classes.margin} InputProps={{ disableUnderline: true }} name="age" disabled={true} id="age" value={input.age} onChange={handleChange} fullWidth label="อายุ" />
                                        </div>
                                        <div className="col-3">
                                            <CssTextField className={classes.margin} InputProps={{ disableUnderline: true }} required error={true} name="Nationality" id="Nationality" onChange={handleChange} fullWidth label="สัญชาติ" />
                                        </div>
                                        <div className="col-6">
                                            <CssTextField type="number"
                                                onInput={(e) => {
                                                    e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 13)
                                                }}
                                                required error={true} name="NationalityId" id="NationalityId" onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="บัตรประจำตัวประชาชน" />
                                        </div>
                                        <div className="col-6">
                                            <CssTextField type="email" required error={true} name="Email" id="Email" onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="อีเมล" />
                                        </div>
                                        <div className="col-12">
                                            <Autocomplete
                                                id="IssuerDistrict"
                                                name="IssuerDistrict"
                                                getOptionSelected={(option, value) => option === value}
                                                open={openIssuerDistrict}
                                                onOpen={() => {
                                                    setOpenIssuerDistrict(true);
                                                }}
                                                onClose={() => {
                                                    setOpenIssuerDistrict(false);
                                                }}
                                                onChange={(e, value) => handleSetIssuerAddress(value)}
                                                inputValue={input.IssuerDistrict}
                                                getOptionLabel={(option) => option.DistrictName || ''}
                                                renderOption={(option) => (
                                                    <Typography className={classes.comboOptions}>
                                                        จ.{option?.ProvinceName} / อ.{option?.DistrictName}


                                                    </Typography>
                                                )}
                                                options={options}

                                                loading={loadingIssuerDistrict}
                                                renderInput={(params) =>
                                                    <CssTextField type="text" required error className={classes.margin} id="IssuerDistrict" name="IssuerDistrict" onChange={handleChange}   {...params} InputProps={
                                                        {
                                                            ...params.InputProps, disableUnderline: true, endAdornment: (
                                                                <React.Fragment>
                                                                    {loadingIssuerDistrict ? <CircularProgress color="inherit" size={20} /> : null}
                                                                    {params.InputProps.endAdornment}
                                                                </React.Fragment>
                                                            ),
                                                        }
                                                    } label="ออกให้ ณ อำเภอ/เขต" />}
                                            />
                                        </div>

                                        <div className="col-12">
                                            <Autocomplete
                                                id="IssuerProvince"
                                                name="IssuerProvince"
                                                getOptionSelected={(option, value) => option === value}
                                                open={openIssuerProvince}
                                                onOpen={() => {
                                                    setOpenIssuerProvince(true);
                                                }}
                                                onClose={() => {
                                                    setOpenIssuerProvince(false);
                                                }}
                                                onChange={(e, value) => handleSetIssuerAddress(value)}
                                                inputValue={input.IssuerProvince}
                                                getOptionLabel={(option) => option.ProvinceName || ''}
                                                renderOption={(option) => (
                                                    <Typography className={classes.comboOptions}>
                                                        จ.{option?.ProvinceName} / อ.{option?.DistrictName}

                                                    </Typography>
                                                )}
                                                options={options}

                                                loading={loadingIssuerProvince}
                                                renderInput={(params) =>
                                                    <CssTextField type="text" required error className={classes.margin} id="IssuerProvince" name="IssuerProvince" onChange={handleChange}   {...params} InputProps={
                                                        {
                                                            ...params.InputProps, disableUnderline: true, endAdornment: (
                                                                <React.Fragment>
                                                                    {loadingIssuerProvince ? <CircularProgress color="inherit" size={20} /> : null}
                                                                    {params.InputProps.endAdornment}
                                                                </React.Fragment>
                                                            ),
                                                        }
                                                    } label="จังหวัด" />}
                                            />
                                        </div>


                                        {/* <div className="col-12">
                                            <CssTextField type="text" required error={true} name="ContactName" id="ContactName" onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="ชื่อร้านค้า" />
                                        </div> */}






                                        {/* <div className="col-6">
                                     
                                            <MuiPickersUtilsProvider utils={OverwriteMomentBE} locale="th">
                                                <DatePicker

                                                    name="BirthDate"
                                                    id="BirthDate"
                                                    maxDate={new Date()}
                                                    format='DD/MM/YYYY'
                                                    label="วันเกิด"
                                                    required={true}
                                                    error={true}
                                                    onChange={handleBirthdayChange}
                                                    value={input.BirthDate}
                                                    TextFieldComponent={renderInput}



                                                />
                                            </MuiPickersUtilsProvider>
                                        </div>
                          
                                        <div className="col-3">
                                            <CssTextField className={classes.margin} InputProps={{ disableUnderline: true }} name="age" disabled={true} id="age" value={input.age} onChange={handleChange} fullWidth label="อายุ" />
                                        </div>
                                        <div className="col-3">
                                            <CssTextField className={classes.margin} InputProps={{ disableUnderline: true }} required error={true} name="Nationality" id="Nationality" onChange={handleChange} fullWidth label="สัญชาติ" />
                                        </div> */}
                                    </div>


                                    <Typography variant="h6" style={{
                                        marginBottom: '15px'
                                    }}>
                                        ที่อยู่ตามบัตรประชาชน
                                    </Typography>

                                    <div className="row">
                                        <div className="col-6">
                                            {/* <TextField id="test" key="test" label="Outlined" variant="outlined" /> */}

                                            <CssTextField type="text" name="HouseNumber" id="HouseNumber" onChange={handleChange} className={classes.margin} required error={true} InputProps={{ disableUnderline: true }} fullWidth label="ที่อยู่เลขที่" />
                                        </div>
                                        <div className="col-6">
                                            <CssTextField type="text" name="Moo" id="Moo" onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="หมู่" />
                                        </div>
                                        <div className="col-6">
                                            <CssTextField type="text" name="Alley" id="Alley" onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="ตรอก/ซอย" />
                                        </div>
                                        <div className="col-6">
                                            <CssTextField type="text" name="Address" id="Address" onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="ถนน" />
                                        </div>
                                        <div className="col-12">
                                            {/* <CssTextField type="text" name="SubDistrict" required error={true} onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth  label="ตำบล/แขวง" /> */}

                                            <Autocomplete
                                                id="SubDistrict"
                                                name="SubDistrict"
                                                getOptionSelected={(option, value) => option === value}
                                                open={openSubDistrict}
                                                onOpen={() => {
                                                    setOpenSubDistrict(true);
                                                }}
                                                onClose={() => {
                                                    setOpenSubDistrict(false);
                                                }}
                                                onChange={(e, value) => handleClickAutoComplete(value)}
                                                inputValue={input.SubDistrict}
                                                getOptionLabel={(option) => option.SubDistrictName || ''}
                                                renderOption={(option) => (
                                                    <Typography className={classes.comboOptions}>
                                                        จ.{option?.ProvinceName} / อ.{option?.DistrictName} /
                                                        ต.{option?.SubDistrictName} / {option?.Zipcode}

                                                    </Typography>
                                                )}
                                                options={options}

                                                loading={loadingSubDistrict}
                                                renderInput={(params) =>
                                                    <CssTextField type="text" required error className={classes.margin} id="SubDistrict" name="SubDistrict" onChange={handleChange}   {...params} InputProps={
                                                        {
                                                            ...params.InputProps, disableUnderline: true, endAdornment: (
                                                                <React.Fragment>
                                                                    {loadingSubDistrict ? <CircularProgress color="inherit" size={20} /> : null}
                                                                    {params.InputProps.endAdornment}
                                                                </React.Fragment>
                                                            ),
                                                        }
                                                    } label="ตำบล/แขวง" />}
                                            />
                                        </div>
                                        <div className="col-12">
                                            {/* <CssTextField type="text" name="District" required error={true} onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth  label="อำเภอ/เขต" /> */}

                                            <Autocomplete
                                                id="District"
                                                name="District"
                                                inputValue={input.District}
                                                open={openDistrict}
                                                getOptionSelected={(option, value) => option === value}
                                                onOpen={() => {
                                                    setOpenDistrict(true);
                                                }}
                                                onClose={() => {
                                                    setOpenDistrict(false);
                                                }}

                                                onChange={(e, value) => handleClickAutoComplete(value)}
                                                getOptionLabel={(option) => option.DistrictName || ""}
                                                renderOption={(option) => (
                                                    <Typography className={classes.comboOptions}>
                                                        จ.{option?.ProvinceName} / อ.{option?.DistrictName} /
                                                        ต.{option?.SubDistrictName} / {option?.Zipcode}

                                                    </Typography>
                                                )}
                                                options={options}
                                                loading={loadingDistrict}
                                                renderInput={(params) =>
                                                    <CssTextField type="text" required error className={classes.margin} id="District" name="District" onChange={handleChange}   {...params} InputProps={
                                                        {
                                                            ...params.InputProps, disableUnderline: true, endAdornment: (
                                                                <React.Fragment>
                                                                    {loadingDistrict ? <CircularProgress color="inherit" size={20} /> : null}
                                                                    {params.InputProps.endAdornment}
                                                                </React.Fragment>
                                                            ),
                                                        }
                                                    } label="อำเภอ/เขต" />}
                                            />
                                        </div>
                                        {/* <div className="col-12">
                                

                                            <Autocomplete
                                                id="combo-box-demo"
                                                options={top100Films}
                                                getOptionLabel={(option) => option.title}
                        
                                                renderInput={(params) => <CssTextField  {...params} name="Province" required error={true} onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth  label="จังหวัด" />}
                                            />
                                        </div> */}
                                        <div className="col-12">
                                            <Autocomplete
                                                id="Province"
                                                name="Province"
                                                getOptionSelected={(option, value) => option === value}
                                                inputValue={input.Province}
                                                onChange={(e, value) => handleClickAutoComplete(value)}
                                                open={openProvince}
                                                onOpen={() => {
                                                    setOpenProvince(true);
                                                }}
                                                onClose={() => {
                                                    setOpenProvince(false);
                                                }}
                                                getOptionLabel={(option) => option.ProvinceName || ""}
                                                renderOption={(option) => (
                                                    <Typography className={classes.comboOptions}>
                                                        จ.{option?.ProvinceName} / อ.{option?.DistrictName} /
                                                        ต.{option?.SubDistrictName} / {option?.Zipcode}

                                                    </Typography>
                                                )}
                                                options={options}
                                                loading={loadingProvince}
                                                renderInput={(params) =>
                                                    <CssTextField type="text" id="Province" required error className={classes.margin} name="Province" onChange={handleChange}   {...params} InputProps={
                                                        {
                                                            ...params.InputProps, disableUnderline: true, endAdornment: (
                                                                <React.Fragment>
                                                                    {loadingProvince ? <CircularProgress color="inherit" size={20} /> : null}
                                                                    {params.InputProps.endAdornment}
                                                                </React.Fragment>
                                                            ),
                                                        }
                                                    } label="จังหวัด" />}
                                            />
                                        </div>
                                        <div className="col-12">
                                            {/* <CssTextField type="text" name="Zipcode" required error={true} onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth  label="ไปรษณีย์" /> */}
                                            <Autocomplete
                                                id="Zipcode"
                                                name="Zipcode"
                                                getOptionSelected={(option, value) => option === value}
                                                inputValue={input.Zipcode ? input.Zipcode.toString() : ''}
                                                onChange={(e, value) => handleClickAutoComplete(value)}
                                                open={openZipcode}
                                                onOpen={() => {
                                                    setOpenZipcode(true);
                                                }}
                                                onClose={() => {
                                                    setOpenZipcode(false);
                                                }}
                                                getOptionLabel={(option) => option.Zipcode ? option.Zipcode.toString() : ''}
                                                renderOption={(option) => (
                                                    <Typography className={classes.comboOptions}>
                                                        จ.{option?.ProvinceName} / อ.{option?.DistrictName} /
                                                        ต.{option?.SubDistrictName} / {option?.Zipcode}

                                                    </Typography>
                                                )}
                                                options={options}
                                                loading={loadingZipcode}
                                                renderInput={(params) =>
                                                    <CssTextField type="text " id="Zipcode" required error className={classes.margin} name="Zipcode" onChange={handleChange}   {...params} InputProps={
                                                        {
                                                            ...params.InputProps, disableUnderline: true, endAdornment: (
                                                                <React.Fragment>
                                                                    {loadingZipcode ? <CircularProgress color="inherit" size={20} /> : null}
                                                                    {params.InputProps.endAdornment}
                                                                </React.Fragment>
                                                            ),
                                                        }
                                                    } label="ไปรษณีย์" />}
                                            />

                                        </div>
                                        <div className="col-6">
                                            <CssTextField className={classes.margin} required error={true} name="Tel" id="Tel" onChange={handleChange} InputProps={{ disableUnderline: true }} fullWidth label="โทรศัพท์" />
                                        </div>
                                        <div className="col-6">
                                            <CssTextField className={classes.margin} InputProps={{ disableUnderline: true }} name="Fax" id="Fax" onChange={handleChange} fullWidth label="โทรสาร" />
                                        </div>
                                    </div>

                                    <FormGroup row style={{
                                        display: 'flex',
                                        alignItems: 'self-start'
                                    }}>
                                        <Typography variant="h6" style={{
                                            marginBottom: '15px',
                                            marginRight: '15px'
                                        }}>
                                            สถานที่จำหน่าย
                                        </Typography>
                                        <FormControlLabel style={{

                                        }}
                                            control={
                                                <Checkbox
                                                    icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                                                    name="coppyNationalityToShopAddress"
                                                    onChange={coppyAddress}
                                                    value={false}
                                                />
                                            }
                                            label={<>
                                                <div style={{
                                                    fontSize: '0.9rem',
                                                    color: 'red'
                                                }}>
                                                    <span>ที่อยู่ตามบัตรประชาชน </span>
                                                </div>

                                            </>}
                                        />

                                        {/* <FormControlLabel
                                            checked={input.coppyOfficeToShopAddress}
                                            control={
                                                <Checkbox
                                                    icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                                                    name="coppyOfficeToShopAddress"

                                                    onChange={coppyAddress}
                                                />
                                            }
                                            label={<>
                                                <div style={{
                                                    fontSize: '0.9rem',
                                                    color: 'red'
                                                }}>
                                                    <span>ที่อยู่สำนักงาน </span>
                                                </div>

                                            </>}


                                        /> */}
                                    </FormGroup>

                                    <div className="row">
                                        <div className="col-12">
                                            <CssTextField type="text" required error={true} name="ContactName" id="ContactName" onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="ชื่อร้านค้า" />
                                        </div>

                                        <div className="col-6">
                                            {/* <TextField id="test" key="test" label="Outlined" variant="outlined" /> */}

                                            <CssTextField type="text" name="ShopHouseNumber" id="ShopHouseNumber" value={input.ShopHouseNumber} onChange={handleChange} className={classes.margin} required error={true} InputProps={{ disableUnderline: true }} fullWidth label="ที่อยู่เลขที่" />
                                        </div>
                                        <div className="col-6">
                                            <CssTextField type="text" name="ShopMoo" id="ShopMoo" value={input.ShopMoo} onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="หมู่" />
                                        </div>
                                        <div className="col-6">
                                            <CssTextField type="text" name="ShopAlley" id="ShopAlley" value={input.ShopAlley} onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="ตรอก/ซอย" />
                                        </div>
                                        <div className="col-6">
                                            <CssTextField type="text" name="ShopAddress" id="ShopAddress" value={input.ShopAddress} onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="ถนน" />
                                        </div>
                                        <div className="col-12">
                                            {/* <CssTextField type="text" name="SubDistrict" required error={true} onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth  label="ตำบล/แขวง" /> */}

                                            <Autocomplete
                                                id="ShopSubDistrict"
                                                name="ShopSubDistrict"
                                                getOptionSelected={(option, value) => option === value}
                                                open={openShopSubDistrict}
                                                onOpen={() => {
                                                    setOpenShopSubDistrict(true);
                                                }}
                                                onClose={() => {
                                                    setOpenShopSubDistrict(false);
                                                }}
                                                onChange={(e, value) => handleSetShopAddress(value)}
                                                inputValue={input.ShopSubDistrict}
                                                getOptionLabel={(option) => option.SubDistrictName || ''}
                                                renderOption={(option) => (
                                                    <Typography className={classes.comboOptions}>
                                                        จ.{option?.ProvinceName} / อ.{option?.DistrictName} /
                                                        ต.{option?.SubDistrictName} / {option?.Zipcode}

                                                    </Typography>
                                                )}
                                                options={options}

                                                loading={loadingShopSubDistrict}
                                                renderInput={(params) =>
                                                    <CssTextField type="text" required error className={classes.margin} id="ShopSubDistrict" name="ShopSubDistrict" onChange={handleChange}   {...params} InputProps={
                                                        {
                                                            ...params.InputProps, disableUnderline: true, endAdornment: (
                                                                <React.Fragment>
                                                                    {loadingShopSubDistrict ? <CircularProgress color="inherit" size={20} /> : null}
                                                                    {params.InputProps.endAdornment}
                                                                </React.Fragment>
                                                            ),
                                                        }
                                                    } label="ตำบล/แขวง" />}
                                            />
                                        </div>
                                        <div className="col-12">
                                            {/* <CssTextField type="text" name="District" required error={true} onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth  label="อำเภอ/เขต" /> */}

                                            <Autocomplete
                                                id="ShopDistrict"
                                                name="ShopDistrict"
                                                inputValue={input.ShopDistrict}
                                                open={openShopDistrict}
                                                getOptionSelected={(option, value) => option === value}
                                                onOpen={() => {
                                                    setOpenShopDistrict(true);
                                                }}
                                                onClose={() => {
                                                    setOpenShopDistrict(false);
                                                }}

                                                onChange={(e, value) => handleSetShopAddress(value)}
                                                getOptionLabel={(option) => option.DistrictName || ""}
                                                renderOption={(option) => (
                                                    <Typography className={classes.comboOptions}>
                                                        จ.{option?.ProvinceName} / อ.{option?.DistrictName} /
                                                        ต.{option?.SubDistrictName} / {option?.Zipcode}

                                                    </Typography>
                                                )}
                                                options={options}
                                                loading={loadingShopDistrict}
                                                renderInput={(params) =>
                                                    <CssTextField type="text" required error className={classes.margin} id="ShopDistrict" name="ShopDistrict" onChange={handleChange}   {...params} InputProps={
                                                        {
                                                            ...params.InputProps, disableUnderline: true, endAdornment: (
                                                                <React.Fragment>
                                                                    {loadingShopDistrict ? <CircularProgress color="inherit" size={20} /> : null}
                                                                    {params.InputProps.endAdornment}
                                                                </React.Fragment>
                                                            ),
                                                        }
                                                    } label="อำเภอ/เขต" />}
                                            />
                                        </div>
                                        {/* <div className="col-12">
                                

                                            <Autocomplete
                                                id="combo-box-demo"
                                                options={top100Films}
                                                getOptionLabel={(option) => option.title}
                        
                                                renderInput={(params) => <CssTextField  {...params} name="Province" required error={true} onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth  label="จังหวัด" />}
                                            />
                                        </div> */}
                                        <div className="col-12">
                                            <Autocomplete
                                                id="ShopProvince"
                                                name="ShopProvince"
                                                getOptionSelected={(option, value) => option === value}
                                                inputValue={input.ShopProvince}
                                                onChange={(e, value) => handleSetShopAddress(value)}
                                                open={openShopProvince}
                                                onOpen={() => {
                                                    setOpenShopProvince(true);
                                                }}
                                                onClose={() => {
                                                    setOpenShopProvince(false);
                                                }}
                                                getOptionLabel={(option) => option.ProvinceName || ""}
                                                renderOption={(option) => (
                                                    <Typography className={classes.comboOptions}>
                                                        จ.{option?.ProvinceName} / อ.{option?.DistrictName} /
                                                        ต.{option?.SubDistrictName} / {option?.Zipcode}

                                                    </Typography>
                                                )}
                                                options={options}
                                                loading={loadingShopProvince}
                                                renderInput={(params) =>
                                                    <CssTextField type="text" id="ShopProvince" required error className={classes.margin} name="ShopProvince" onChange={handleChange}   {...params} InputProps={
                                                        {
                                                            ...params.InputProps, disableUnderline: true, endAdornment: (
                                                                <React.Fragment>
                                                                    {loadingShopProvince ? <CircularProgress color="inherit" size={20} /> : null}
                                                                    {params.InputProps.endAdornment}
                                                                </React.Fragment>
                                                            ),
                                                        }
                                                    } label="จังหวัด" />}
                                            />
                                        </div>
                                        <div className="col-12">
                                            {/* <CssTextField type="text" name="Zipcode" required error={true} onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth  label="ไปรษณีย์" /> */}
                                            <Autocomplete
                                                id="ShopZipcode"
                                                name="ShopZipcode"
                                                getOptionSelected={(option, value) => option === value}
                                                inputValue={input.ShopZipcode ? input.ShopZipcode.toString() : ''}
                                                onChange={(e, value) => handleSetShopAddress(value)}
                                                open={openShopZipcode}
                                                onOpen={() => {
                                                    setOpenShopZipcode(true);
                                                }}
                                                onClose={() => {
                                                    setOpenShopZipcode(false);
                                                }}
                                                getOptionLabel={(option) => option.Zipcode ? option.Zipcode.toString() : ''}
                                                renderOption={(option) => (
                                                    <Typography className={classes.comboOptions}>
                                                        จ.{option?.ProvinceName} / อ.{option?.DistrictName} /
                                                        ต.{option?.SubDistrictName} / {option?.Zipcode}

                                                    </Typography>
                                                )}
                                                options={options}
                                                loading={loadingShopZipcode}
                                                renderInput={(params) =>
                                                    <CssTextField type="text " id="ShopZipcode" required error className={classes.margin} name="ShopZipcode" onChange={handleChange}   {...params} InputProps={
                                                        {
                                                            ...params.InputProps, disableUnderline: true, endAdornment: (
                                                                <React.Fragment>
                                                                    {loadingShopZipcode ? <CircularProgress color="inherit" size={20} /> : null}
                                                                    {params.InputProps.endAdornment}
                                                                </React.Fragment>
                                                            ),
                                                        }
                                                    } label="ไปรษณีย์" />}
                                            />

                                        </div>
                                        <div className="col-6">
                                            <CssTextField className={classes.margin} required error={true} name="ShopTel" id="ShopTel" onChange={handleChange} InputProps={{ disableUnderline: true }} fullWidth label="โทรศัพท์" />
                                        </div>
                                        <div className="col-6">
                                            <CssTextField className={classes.margin} InputProps={{ disableUnderline: true }} name="ShopFax" id="ShopFax" onChange={handleChange} fullWidth label="โทรสาร" />
                                        </div>
                                    </div>
                                    <FormGroup row style={{
                                        display: 'flex',
                                        alignItems: 'self-start',
                                        marginBottom: '15px',
                                    }}>
                                        <Typography variant="h6" style={{

                                            marginRight: '15px'
                                        }}>
                                            ที่อยู่สำนักงาน
                                        </Typography>
                                        <FormControlLabel
                                            checked={input.coppyNationalityToOfficeAddress}
                                            control={
                                                <Checkbox
                                                    icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                                                    name="coppyNationalityToOfficeAddress"

                                                    onChange={coppyAddress}
                                                />
                                            }
                                            label={<>
                                                <div style={{
                                                    fontSize: '0.9rem',
                                                    color: 'red'
                                                }}>
                                                    <span>ที่อยู่ตามบัตรประชาชน </span>
                                                </div>

                                            </>}


                                        />

                                        <FormControlLabel
                                            checked={input.coppyShopToOfficeAddress}
                                            control={
                                                <Checkbox
                                                    icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                                                    name="coppyShopToOfficeAddress"

                                                    onChange={coppyAddress}
                                                />
                                            }
                                            label={<>
                                                <div style={{
                                                    fontSize: '0.9rem',
                                                    color: 'red'
                                                }}>
                                                    <span>ที่อยู่ตามสถานที่จำหน่าย </span>
                                                </div>

                                            </>}


                                        />

                                    </FormGroup>

                                    <div className="row">


                                        <div className="col-6">
                                            {/* <TextField id="test" key="test" label="Outlined" variant="outlined" /> */}

                                            <CssTextField type="text" name="OfficeHouseNumber" value={input.OfficeHouseNumber} id="OfficeHouseNumber" onChange={handleChange} className={classes.margin} required error={true} InputProps={{ disableUnderline: true }} fullWidth label="ที่อยู่เลขที่" />
                                        </div>
                                        <div className="col-6">
                                            <CssTextField type="text" name="OfficeMoo" value={input.OfficeMoo} id="OfficeMoo" onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="หมู่" />
                                        </div>
                                        <div className="col-6">
                                            <CssTextField type="text" name="OfficeAlley" value={input.OfficeAlley} id="OfficeAlley" onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="ตรอก/ซอย" />
                                        </div>
                                        <div className="col-6">
                                            <CssTextField type="text" name="OfficeAddress" value={input.OfficeAddress} id="OfficeAddress" onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="ถนน" />
                                        </div>
                                        <div className="col-12">
                                            {/* <CssTextField type="text" name="SubDistrict" required error={true} onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth  label="ตำบล/แขวง" /> */}

                                            <Autocomplete
                                                id="OfficeSubDistrict"
                                                name="OfficeSubDistrict"
                                                getOptionSelected={(option, value) => option === value}
                                                open={openOfficeSubDistrict}
                                                onOpen={() => {
                                                    setOpenOfficeSubDistrict(true);
                                                }}
                                                onClose={() => {
                                                    setOpenOfficeSubDistrict(false);
                                                }}
                                                onChange={(e, value) => handleSetOfficeAddress(value)}
                                                inputValue={input.OfficeSubDistrict}
                                                getOptionLabel={(option) => option.SubDistrictName || ''}
                                                renderOption={(option) => (
                                                    <Typography className={classes.comboOptions}>
                                                        จ.{option?.ProvinceName} / อ.{option?.DistrictName} /
                                                        ต.{option?.SubDistrictName} / {option?.Zipcode}

                                                    </Typography>
                                                )}
                                                options={options}

                                                loading={loadingOfficeSubDistrict}
                                                renderInput={(params) =>
                                                    <CssTextField type="text" required error className={classes.margin} id="OfficeSubDistrict" name="OfficeSubDistrict" onChange={handleChange}   {...params} InputProps={
                                                        {
                                                            ...params.InputProps, disableUnderline: true, endAdornment: (
                                                                <React.Fragment>
                                                                    {loadingOfficeSubDistrict ? <CircularProgress color="inherit" size={20} /> : null}
                                                                    {params.InputProps.endAdornment}
                                                                </React.Fragment>
                                                            ),
                                                        }
                                                    } label="ตำบล/แขวง" />}
                                            />
                                        </div>
                                        <div className="col-12">
                                            {/* <CssTextField type="text" name="District" required error={true} onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth  label="อำเภอ/เขต" /> */}

                                            <Autocomplete
                                                id="OfficeDistrict"
                                                name="OfficeDistrict"
                                                inputValue={input.OfficeDistrict}
                                                open={openOfficeDistrict}
                                                getOptionSelected={(option, value) => option === value}
                                                onOpen={() => {
                                                    setOpenOfficeDistrict(true);
                                                }}
                                                onClose={() => {
                                                    setOpenOfficeDistrict(false);
                                                }}

                                                onChange={(e, value) => handleSetOfficeAddress(value)}
                                                getOptionLabel={(option) => option.DistrictName || ""}
                                                renderOption={(option) => (
                                                    <Typography className={classes.comboOptions}>
                                                        จ.{option?.ProvinceName} / อ.{option?.DistrictName} /
                                                        ต.{option?.SubDistrictName} / {option?.Zipcode}

                                                    </Typography>
                                                )}
                                                options={options}
                                                loading={loadingOfficeDistrict}
                                                renderInput={(params) =>
                                                    <CssTextField type="text" required error className={classes.margin} id="OfficeDistrict" name="OfficeDistrict" onChange={handleChange}   {...params} InputProps={
                                                        {
                                                            ...params.InputProps, disableUnderline: true, endAdornment: (
                                                                <React.Fragment>
                                                                    {loadingOfficeDistrict ? <CircularProgress color="inherit" size={20} /> : null}
                                                                    {params.InputProps.endAdornment}
                                                                </React.Fragment>
                                                            ),
                                                        }
                                                    } label="อำเภอ/เขต" />}
                                            />
                                        </div>
                                        {/* <div className="col-12">
                                

                                            <Autocomplete
                                                id="combo-box-demo"
                                                options={top100Films}
                                                getOptionLabel={(option) => option.title}
                        
                                                renderInput={(params) => <CssTextField  {...params} name="Province" required error={true} onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth  label="จังหวัด" />}
                                            />
                                        </div> */}
                                        <div className="col-12">
                                            <Autocomplete
                                                id="OfficeProvince"
                                                name="OfficeProvince"
                                                getOptionSelected={(option, value) => option === value}
                                                inputValue={input.OfficeProvince}
                                                onChange={(e, value) => handleSetOfficeAddress(value)}
                                                open={openOfficeProvince}
                                                onOpen={() => {
                                                    setOpenOfficeProvince(true);
                                                }}
                                                onClose={() => {
                                                    setOpenOfficeProvince(false);
                                                }}
                                                getOptionLabel={(option) => option.ProvinceName || ""}
                                                renderOption={(option) => (
                                                    <Typography className={classes.comboOptions}>
                                                        จ.{option?.ProvinceName} / อ.{option?.DistrictName} /
                                                        ต.{option?.SubDistrictName} / {option?.Zipcode}

                                                    </Typography>
                                                )}
                                                options={options}
                                                loading={loadingOfficeProvince}
                                                renderInput={(params) =>
                                                    <CssTextField type="text" id="OfficeProvince" required error className={classes.margin} name="OfficeProvince" onChange={handleChange}   {...params} InputProps={
                                                        {
                                                            ...params.InputProps, disableUnderline: true, endAdornment: (
                                                                <React.Fragment>
                                                                    {loadingOfficeProvince ? <CircularProgress color="inherit" size={20} /> : null}
                                                                    {params.InputProps.endAdornment}
                                                                </React.Fragment>
                                                            ),
                                                        }
                                                    } label="จังหวัด" />}
                                            />
                                        </div>
                                        <div className="col-12">
                                            {/* <CssTextField type="text" name="Zipcode" required error={true} onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth  label="ไปรษณีย์" /> */}
                                            <Autocomplete
                                                id="OfficeZipcode"
                                                name="OfficeZipcode"
                                                getOptionSelected={(option, value) => option === value}
                                                inputValue={input.OfficeZipcode ? input.OfficeZipcode.toString() : ''}
                                                onChange={(e, value) => handleSetOfficeAddress(value)}
                                                open={openOfficeZipcode}
                                                onOpen={() => {
                                                    setOpenOfficeZipcode(true);
                                                }}
                                                onClose={() => {
                                                    setOpenOfficeZipcode(false);
                                                }}
                                                getOptionLabel={(option) => option.Zipcode ? option.Zipcode.toString() : ''}
                                                renderOption={(option) => (
                                                    <Typography className={classes.comboOptions}>
                                                        จ.{option?.ProvinceName} / อ.{option?.DistrictName} /
                                                        ต.{option?.SubDistrictName} / {option?.Zipcode}

                                                    </Typography>
                                                )}
                                                options={options}
                                                loading={loadingOfficeZipcode}
                                                renderInput={(params) =>
                                                    <CssTextField type="text " id="OfficeZipcode" required error className={classes.margin} name="OfficeZipcode" onChange={handleChange}   {...params} InputProps={
                                                        {
                                                            ...params.InputProps, disableUnderline: true, endAdornment: (
                                                                <React.Fragment>
                                                                    {loadingOfficeZipcode ? <CircularProgress color="inherit" size={20} /> : null}
                                                                    {params.InputProps.endAdornment}
                                                                </React.Fragment>
                                                            ),
                                                        }
                                                    } label="ไปรษณีย์" />}
                                            />

                                        </div>

                                        <div className="col-6">
                                            <CssTextField className={classes.margin} required error={true} name="OfficeTel" id="OfficeTel" onChange={handleChange} InputProps={{ disableUnderline: true }} fullWidth label="โทรศัพท์" />
                                        </div>
                                        <div className="col-6">
                                            <CssTextField className={classes.margin} InputProps={{ disableUnderline: true }} name="OfficeFax" id="OfficeFax" onChange={handleChange} fullWidth label="โทรสาร" />
                                        </div>

                                    </div>



                                    <div className="row">
                                        <FormControlLabel
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                // marginTop: '20px'
                                            }}
                                            control={
                                                <Checkbox
                                                    name="term"
                                                    color="primary"
                                                    onChange={handleChange}
                                                />
                                            }
                                            label={<>
                                                <div style={{
                                                    fontSize: '0.9rem',
                                                    fontWeight: 'bold'
                                                }}>
                                                    <span>ยอมรับ </span> <span onClick={register} style={{
                                                        textDecoration: 'underline',
                                                        color: '#FBBE66'
                                                    }}>เงื่อนไขข้อตกลง</span> <span>ในการสมัครตัวแทน</span>
                                                </div>

                                            </>}
                                        />
                                    </div>


                                    <div className="row mt-3">

                                        <Button variant="contained" type="submit" className={classes.buttonConfirm} disabled={isLoading} color="primary"
                                        >{isLoading ? <div className="spinner-border text-light" role="status">
                                            <span className="sr-only"></span>
                                        </div> : 'สมัครสมาชิก'}</Button>
                                    </div>
                                </form>
                            </div>

                        </div>
                        <div className="col-lg-6 col-md-12" >
                            <div className={HomeStyles.card} style={{
                                minHeight: '128vh'
                            }}>


                                <Typography variant="h4" className={classes.title}>
                                    เอกสารหลักฐานประกอบการสมัคร
                                </Typography>
                                <Typography variant="h6" style={{
                                    marginBottom: '15px'
                                }}>
                                    อัพโหลดเอกสาร
                                </Typography>
                                <div className="row">
                                    <div className="col-10">

                                        <CssTextField type="text" id="IdCardFiles" name="IdCardFiles" error required className={classes.margin} InputProps={{ disableUnderline: true }} disabled fullWidth id="standard-error-helper-text" label="สำเนาบัตรประจำตัวประชาชน" />
                                        <input type="file"
                                            name="IdCardFiles"
                                            ref={IdCardFiles}
                                            onChange={handleChangeFile}
                                            style={{ display: 'none' }}
                                        />

                                    </div>
                                    <div className="col-2 p-0">
                                        <Button variant="contained" className={classes.buttonUpload} onClick={handleClickUploadIdCardFiles}
                                        >เลือกไฟล์</Button>
                                        {verifyCheck.IdCardFiles &&
                                            <CheckIcon style={
                                                {
                                                    color: 'green',
                                                    position: 'absolute',
                                                    marginTop: '15px',
                                                    marginLeft: '10px'
                                                }
                                            } />
                                        }
                                    </div>



                                    <div className="col-10">
                                        <CssTextField type="text" name="JuristicPersonFiles" disabled required error className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth id="standard-error-helper-text" label="สำเนาหนังสือจดทะเบียนเป็นนิติบุคคลหรือทะเบียนพาณิชย์" />
                                        <input type="file"
                                            name="JuristicPersonFiles"
                                            ref={JuristicPersonFiles}
                                            onChange={handleChangeFile}
                                            style={{ display: 'none' }}
                                        />
                                    </div>
                                    <div className="col-2 p-0">
                                        <Button variant="contained" className={classes.buttonUpload} onClick={handleClickUploadJuristicPersonFiles}
                                        >เลือกไฟล์</Button>
                                        {verifyCheck.JuristicPersonFiles &&
                                            <CheckIcon style={
                                                {
                                                    color: 'green',
                                                    position: 'absolute',
                                                    marginTop: '15px',
                                                    marginLeft: '10px'
                                                }
                                            } />
                                        }
                                    </div>

                                    <div className="col-10">
                                        <CssTextField type="text" name="LicenseFiles" disabled className={classes.margin} required error InputProps={{ disableUnderline: true }} fullWidth label="ใบอนุญาตขายเมล็ดพันธุ์ควบคุม (พ.พ.4)" />
                                        <input type="file"
                                            name="LicenseFiles"
                                            ref={LicenseFiles}
                                            onChange={handleChangeFile}
                                            style={{ display: 'none' }}
                                        />
                                    </div>
                                    <div className="col-2 p-0">
                                        <Button variant="contained" className={classes.buttonUpload} onClick={handleClickUploadLicenseFiles}
                                        >เลือกไฟล์</Button>
                                        {verifyCheck.LicenseFiles &&
                                            <CheckIcon style={
                                                {
                                                    color: 'green',
                                                    position: 'absolute',
                                                    marginTop: '15px',
                                                    marginLeft: '10px'
                                                }
                                            } />
                                        }
                                    </div>

                                    <div className="col-10">
                                        <CssTextField type="text" name="StoreMapFiles" disabled className={classes.margin} required error InputProps={{ disableUnderline: true }} fullWidth label="แผนผังแสดงที่อยู่และสถานที่ตั้งของสถานที่จำหน่ายเมล็ดพันธุ์" />
                                        <input type="file"
                                            name="StoreMapFiles"
                                            ref={StoreMapFiles}
                                            onChange={handleChangeFile}
                                            style={{ display: 'none' }}
                                        />
                                    </div>
                                    <div className="col-2 p-0">
                                        <Button variant="contained" className={classes.buttonUpload} onClick={handleClickUploadStoreMapFiles}
                                        >เลือกไฟล์</Button>
                                        {verifyCheck.StoreMapFiles &&
                                            <CheckIcon style={
                                                {
                                                    color: 'green',
                                                    position: 'absolute',
                                                    marginTop: '15px',
                                                    marginLeft: '10px'
                                                }
                                            } />
                                        }

                                    </div>

                                    <div className="col-10">
                                        <CssTextField type="text" name="ProxyFiles" disabled InputProps={{ disableUnderline: true }} fullWidth label="หนังสือมอบอำนาจซึ่งติดอากรแสตมป์ตามกฎหมาย" />
                                        <input type="file"
                                            name="ProxyFiles"
                                            ref={ProxyFiles}
                                            onChange={handleChangeFile}
                                            style={{ display: 'none' }}
                                        />
                                        <Typography variant="h6" style={{
                                            marginBottom: '15px',
                                            marginTop: '5px',
                                            color: '#F35162',
                                            fontSize: '12px',
                                            // fontWeight: 'bold'
                                        }}>
                                            โปรดอัพโหลดสำเนาบัตรประชาชนผู้มีอำนาจลงนามแทนในช่อง "เอกสารอื่นๆ"
                                        </Typography>
                                    </div>
                                    <div className="col-2 p-0">
                                        <Button variant="contained" className={classes.buttonUpload} onClick={handleClickUploadProxyFiles}
                                        >เลือกไฟล์</Button>
                                        {verifyCheck.ProxyFiles &&
                                            <CheckIcon style={
                                                {
                                                    color: 'green',
                                                    position: 'absolute',
                                                    marginTop: '15px',
                                                    marginLeft: '10px'
                                                }
                                            } />
                                        }
                                    </div>

                                    <div className="col-10">
                                        <CssTextField type="text" name="OtherFiles" disabled className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="เอกสารอื่นๆ" />
                                        <input type="file"
                                            name="OtherFiles"
                                            ref={OtherFiles}
                                            onChange={handleChangeFile}
                                            style={{ display: 'none' }}
                                        />
                                    </div>
                                    <div className="col-2 p-0">
                                        <Button variant="contained" className={classes.buttonUpload} onClick={handleClickUploadOtherFiles}
                                        >เลือกไฟล์</Button>
                                        {verifyCheck.OtherFiles &&
                                            <CheckIcon style={
                                                {
                                                    color: 'green',
                                                    position: 'absolute',
                                                    marginTop: '15px',
                                                    marginLeft: '10px'
                                                }
                                            } />
                                        }
                                    </div>
                                    <div className="col-12">
                                        <Typography variant="h6" style={{
                                            marginBottom: '15px',
                                            color: '#F35162',
                                            fontSize: '13px',
                                            // fontWeight: 'bold'
                                        }}>
                                            สำเนาหลักฐานทุกฉบับให้ผู้สมัครเขียนรับรอง "สำเนาถูกต้อง" และลงชื่อกำกับไว้ด้วย
                                        </Typography>
                                        <hr style={{
                                            color: 'gray'
                                        }}>

                                        </hr>
                                    </div>

                                    <Typography variant="h6" style={{
                                        marginBottom: '15px'
                                    }}>
                                        ไฟล์ที่อัพโหลด
                                    </Typography>


                                    <div className="col-lg-12 col-sm-12 mb-3" >

                                        {files.map((file) =>
                                            <div className="files-uploaded"  >
                                                <div className="icon-file">
                                                    <img src={file.pathImg} alt="file-uploaded" className="file-uploaded" />
                                                </div>
                                                <div className="file-info">
                                                    <div className="file-h1">
                                                        {file.typeShow}
                                                    </div>
                                                    <div className="file-d1">
                                                        {file.file.name}
                                                    </div>
                                                </div>
                                                <div className="file-remove">

                                                    <HighlightOffIcon style={{
                                                        color: 'red',
                                                        fontSize: '2rem',
                                                        cursor: 'pointer'
                                                    }} onClick={() => handleRemove(file)}></HighlightOffIcon>
                                                </div>
                                            </div>
                                        )}

                                    </div>
                                    <hr style={{
                                        color: 'gray'
                                    }}>

                                    </hr>
                                    <Typography variant="h6" style={{
                                        marginBottom: '15px'
                                    }}>
                                        ชนิดพืช/พันธุ์  ที่ประสงค์จะขอเป็นตัวแทนจำหน่ายเมล็ดพันธุ์พืช  เบื้องต้น
                                    </Typography>
                                    <div className="col-12">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr style={{
                                                    background: '#4472c4',
                                                    color: 'white'
                                                }}>
                                                    <th scope="col" className="text-center">ชนิดพืช</th>
                                                    {/* <th scope="col" className="text-center">หลัก (ตัน)</th> */}
                                                    <th scope="col" className="text-center">พันธุ์</th>
                                                    <th scope="col" className="text-center">ปริมาณการขาย (ตัน/ปี)</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <select className="form-select" name="ItemTypeName_1" onChange={handleChange} aria-label="Default select example">
                                                            <option value=''>-</option>
                                                            {typeList.map((option) => (

                                                                <>

                                                                    <option key={option} value={option.TypeName}> {option.TypeName}</option>

                                                                </>
                                                            ))}

                                                        </select>
                                                    </td>
                                                    <td>
                                                        <select className="form-select" name="ItemCatalogName_1" onChange={handleChange} aria-label="Default select example">
                                                            <option value=''>-</option>
                                                            {catalogList.map((option) => (

                                                                <>

                                                                    <option key={option} value={option.CatalogName}> {option.CatalogName}</option>

                                                                </>
                                                            ))}

                                                        </select>
                                                    </td>
                                                    <td>
                                                        <input type="text" maxLength={5} onKeyPress={(event) => {
                                                            if (!/[0-9]/.test(event.key)) {
                                                                event.preventDefault();
                                                            }
                                                        }} name="ItemSaleAmount_1" onChange={handleChange} className="form-control" ></input>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <select className="form-select" name="ItemTypeName_2" onChange={handleChange} aria-label="Default select example">
                                                            <option value=''>-</option>
                                                            {typeList.map((option) => (

                                                                <>
                                                                    <option key={option} value={option.TypeName}> {option.TypeName}</option>

                                                                </>
                                                            ))}

                                                        </select>
                                                    </td>
                                                    <td>
                                                        <select className="form-select" name="ItemCatalogName_2" onChange={handleChange} aria-label="Default select example">
                                                            <option value=''>-</option>
                                                            {catalogList.map((option) => (

                                                                <>

                                                                    <option key={option} value={option.CatalogName}> {option.CatalogName}</option>

                                                                </>
                                                            ))}

                                                        </select>
                                                    </td>
                                                    <td>
                                                        <input type="text" maxLength={5} onKeyPress={(event) => {
                                                            if (!/[0-9]/.test(event.key)) {
                                                                event.preventDefault();
                                                            }
                                                        }} className="form-control" name="ItemSaleAmount_2" onChange={handleChange} ></input>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <select className="form-select" name="ItemTypeName_3" onChange={handleChange} aria-label="Default select example">
                                                            <option value=''>-</option>
                                                            {typeList.map((option) => (

                                                                <>
                                                                    <option key={option} value={option.TypeName}> {option.TypeName}</option>

                                                                </>
                                                            ))}

                                                        </select>
                                                    </td>
                                                    <td>
                                                        <select className="form-select" name="ItemCatalogName_3" onChange={handleChange} aria-label="Default select example">
                                                            <option value=''>-</option>
                                                            {catalogList.map((option) => (

                                                                <>

                                                                    <option key={option} value={option.CatalogName}> {option.CatalogName}</option>

                                                                </>
                                                            ))}

                                                        </select>
                                                    </td>
                                                    <td>
                                                        <input type="text" maxLength={5} onKeyPress={(event) => {
                                                            if (!/[0-9]/.test(event.key)) {
                                                                event.preventDefault();
                                                            }
                                                        }} className="form-control" name="ItemSaleAmount_3" onChange={handleChange} ></input>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <select className="form-select" name="ItemTypeName_4" onChange={handleChange} aria-label="Default select example">
                                                            <option value=''>-</option>
                                                            {typeList.map((option) => (

                                                                <>
                                                                    <option key={option} value={option.TypeName}> {option.TypeName}</option>

                                                                </>
                                                            ))}

                                                        </select>
                                                    </td>
                                                    <td>
                                                        <select className="form-select" name="ItemCatalogName_4" onChange={handleChange} aria-label="Default select example">
                                                            <option value=''>-</option>
                                                            {catalogList.map((option) => (

                                                                <>

                                                                    <option key={option} value={option.CatalogName}> {option.CatalogName}</option>

                                                                </>
                                                            ))}

                                                        </select>
                                                    </td>
                                                    <td>
                                                        <input type="text" maxLength={5} onKeyPress={(event) => {
                                                            if (!/[0-9]/.test(event.key)) {
                                                                event.preventDefault();
                                                            }
                                                        }} name="ItemSaleAmount_4" onChange={handleChange} className="form-control" ></input>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>





                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </Banner>

            <DialogRegister open={open} handleClose={handleClose} email={input.Email} />


            <Polycy
                open={true}
                openPopup={openPopup}
                setOpenPopup={setOpenPopup}
            >

            </Polycy>



        </>
    )

}

export default withSnackbar(Register)

